<template>
    <div>
        <div
            id="content"
            class="content animated slideInRight delay-1s"
        >
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">
                                Cadastrar Centro de Custo
                                <span
                                    class="required_fields"
                                >
                                    <span class="required">*</span>
                                    Campos obrigatórios
                                </span
                                >
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="section-form">
                                <form id="form">
                                    <div class="row">
                                        <div class="col-md-6 mb-3">
                                            <label>
                                                <span class="required">*</span>
                                                Centro de Custo:
                                            </label>
                                            <input
                                                v-model="cost_centers.description"
                                                class="form-control"
                                            >
                                        </div>

                                        <div class="col-md-3 mb-3">
                                            <label>
                                                <span class="required">*</span>
                                                Código ERP:
                                            </label>
                                            <input
                                                v-model="cost_centers.erp_code"
                                                class="form-control"
                                            >
                                        </div>
                                    </div>


                                    <div class="row">
                                        <div class="col-md-6">
                                            <button
                                                type="button"
                                                style="width: auto"
                                                class="btn btn-primary btn-block mb-2"
                                                @click="moveAll('toSelected')"
                                            >
                                                <span class="badge badge-light">{{
                                                        costCentersFiltered.length
                                                                                }}
                                                </span>
                                                <span class="mx-2">
                                                    Mover todas
                                                </span>
                                                <i class="fas fa-arrow-right"></i>
                                            </button>
                                            <input
                                                type="text"
                                                placeholder="Procurar..."
                                                class="form-control mb-2"
                                                v-model="costCenters_search"
                                            />
                                            <ul class="list-group entity-filter-selection">
                                                <li
                                                    style="background-color: #ffcccb"
                                                    class="list-group-item"
                                                    v-for="(city, index) in costCentersFiltered"
                                                    :key="index"
                                                    @click="moveCity(city, index, 'toSelected')"
                                                >
                                                    {{ city.description }}
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-md-6">
                                            <button
                                                type="button"
                                                style="width: auto"
                                                class="btn btn-secondary btn-block mb-2"
                                                @click="moveAll('toNotSelected')"
                                            >
                                                <i class="fas fa-arrow-left"></i>
                                                <span class="mx-2">
                                                    Mover todas
                                                </span>
                                                <span class="badge badge-light">{{
                                                        selectedCostCentersFiltered.length
                                                                                }}
                                                </span>
                                            </button>
                                            <input
                                                type="text"
                                                placeholder="Procurar..."
                                                class="form-control mb-2"
                                                v-model="selectedCosteCenter_search"
                                            />
                                            <ul class="list-group entity-filter-selection">
                                                <li
                                                    style="background-color: #a6f1a6"
                                                    class="list-group-item"
                                                    v-for="(city, index) in selectedCostCentersFiltered"
                                                    :key="'A' + index"
                                                    @click="moveCity(city, index, 'toNotSelected')"
                                                >
                                                    {{ city.description }}
                                                </li>
                                            </ul>
                                        </div>
                                    </div>


                                    <div class="block text-right">
                                        <router-link
                                            to="/cost-centers"
                                            class="btn btn-back"
                                        >
                                            <i class="fa fa-arrow-left mr-2"></i>
                                            Voltar
                                        </router-link>

                                        <a
                                            class="btn btn-add"
                                            @click="save"
                                        >
                                            Salvar
                                            <i class="fa fa-save ml-2"></i>
                                        </a>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {getMessage} from "../../composables/message";
import {toFormData} from "../../composables/cruds";

export default {
    data() {
        return {
            cost_centers: {
                description: "",
                erp_code: ''
            },
            costCenters_search: "",
            selectedCostCenters: [],
            costCenters: [],
            costCentersFiltered: [],
            selectedCostCentersFiltered: [],
            selectedCosteCenter_search: [],
            errors: undefined,
        };
    },
    computed: {},
    methods: {
        matchArrays() {
            this.selectedCostCentersFiltered = this.selectedCostCenters;
            this.costCentersFiltered = this.costCenters;
        },
        moveCity(city, index, method) {
            const self = this;
            if (method == "toSelected") {
                self.costCenters.splice(index, 1);
                self.selectedCostCenters.push(city);
            } else {
                self.selectedCostCenters.splice(index, 1);
                self.costCenters.push(city);
            }

            self.matchArrays();
        },
        moveAll(method) {
            const self = this;
            if (method == "toSelected") {
                self.selectedCostCenters = self.selectedCostCenters.concat(self.costCenters);
                self.costCenters = [];
            } else {
                self.costCenters = self.costCenters.concat(
                    self.selectedCostCenters
                );
                self.selectedCostCenters = [];
            }

            self.matchArrays();
        },
        getCityDestinations: function () {
            const self = this;
            let api = self.$store.state.api + "cost-centers/show-diff/";

            if(self.$route.params.id) api += self.$route.params.id;

            self.$http
                .get(api)
                .then((response) => {
                    response.data.data.forEach((city) => {
                        //Se não estiver selecionado coloca no não selecionado
                        if (self.selectedCostCenters.filter((e) => e.id === city.id).length <= 0) {
                            self.costCenters.push(city);
                        }
                    });
                    self.matchArrays();
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },
        save: function () {
            let url = this.$store.state.api + "cost-centers";
            if (this.cost_centers.id) {
                url = this.$store.state.api + "cost-centers/" + this.cost_centers.id;
                this.cost_centers._method = 'PUT';
            }
            const self = this;

            const data = {
                ...self.cost_centers,
                childrens: self.selectedCostCenters.map((e) => e.id),
            }

            const newFormData = toFormData(data);

            self.$http
                .post(url, newFormData)
                .then((response) => {
                    self.$message("Sucesso", `Centro de Custo cadastrado com sucesso`, "success");
                    this.$router.push("/cost-centers");
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },

        getData(id) {
            const api = this.$store.state.api + "cost-centers/" + id;
            const self = this;

            self.$http
                .get(api)
                .then((response) => {
                    self.cost_centers = response.data.data;
                    self.selectedCostCenters = response.data.data.childrens;
                    this.getCityDestinations();
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    },

    watch: {
        costCenters_search() {
            const self = this;
            self.costCentersFiltered = [];
            for (var i = 0; i < self.costCenters.length; i++) {
                if (
                    self.costCenters[i].description
                        .toLowerCase()
                        .indexOf(self.costCenters_search.toLowerCase()) >= 0
                ) {
                    self.costCentersFiltered.push(self.costCenters[i]);
                }
            }
        },
        selectedCosteCenter_search() {
            const self = this;
            self.selectedCostCentersFiltered = [];
            for (var i = 0; i < self.selectedCostCenters.length; i++) {
                if (
                    self.selectedCostCenters[i].description
                        .toLowerCase()
                        .indexOf(self.selectedCosteCenter_search.toLowerCase()) >= 0
                ) {
                    self.selectedCostCentersFiltered.push(self.selectedCostCenters[i]);
                }
            }
        },
    },

    mounted: function () {
        const id = this.$route.params.id;
        if (id) {
            this.getData(id);
        } else {
            this.getCityDestinations();
        }
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/CostCenter/Add.vue